import { MAIN_PATH } from 'companies/navigation';

const indexComponent = require('./routes/list/components/CompaniesList');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: MAIN_PATH,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/add'),
        require('./routes/show'),
      ]);
    });
  },
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CompaniesManager'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/companies/index.js